/* Timezones from Google Calendar */

export default [
  {
    label: 'Niue',
    value: 'Pacific/Niue',
    offset: -11,
  },
  {
    label: 'Pago Pago',
    value: 'Pacific/Pago_Pago',
    offset: -11,
  },
  {
    label: 'Hawaii Time',
    value: 'Pacific/Honolulu',
    offset: -10,
  },
  {
    label: 'Rarotonga',
    value: 'Pacific/Rarotonga',
    offset: -10,
  },
  {
    label: 'Tahiti',
    value: 'Pacific/Tahiti',
    offset: -10,
  },
  {
    label: 'Gambier',
    value: 'Pacific/Gambier',
    offset: -9,
  },
  {
    label: 'Alaska Time',
    value: 'America/Anchorage',
    offset: -8,
  },
  {
    label: 'Pitcairn',
    value: 'Pacific/Pitcairn',
    offset: -8,
  },
  {
    label: 'Dawson',
    value: 'America/Dawson',
    offset: -7,
  },
  {
    label: 'Phoenix',
    value: 'America/Phoenix',
    offset: -7,
  },
  {
    label: 'Pacific Time',
    value: 'America/Los_Angeles',
    offset: -7,
  },
  {
    label: 'Pacific Time - Tijuana',
    value: 'America/Tijuana',
    offset: -7,
  },
  {
    label: 'Pacific Time - Vancouver',
    value: 'America/Vancouver',
    offset: -7,
  },
  {
    label: 'Pacific Time - Whitehorse',
    value: 'America/Whitehorse',
    offset: -7,
  },
  {
    label: 'Belize',
    value: 'America/Belize',
    offset: -6,
  },
  {
    label: 'Boise',
    value: 'America/Boise',
    offset: -6,
  },
  {
    label: 'Central Time - Regina',
    value: 'America/Regina',
    offset: -6,
  },
  {
    label: 'Central Time - Tegucigalpa',
    value: 'America/Tegucigalpa',
    offset: -6,
  },
  {
    label: 'Costa Rica',
    value: 'America/Costa_Rica',
    offset: -6,
  },
  {
    label: 'Easter Island',
    value: 'Pacific/Easter',
    offset: -6,
  },
  {
    label: 'El Salvador',
    value: 'America/El_Salvador',
    offset: -6,
  },
  {
    label: 'Galapagos',
    value: 'Pacific/Galapagos',
    offset: -6,
  },
  {
    label: 'Guatemala',
    value: 'America/Guatemala',
    offset: -6,
  },
  {
    label: 'Managua',
    value: 'America/Managua',
    offset: -6,
  },
  {
    label: 'Mountain Time',
    value: 'America/Denver',
    offset: -6,
  },
  {
    label: 'Chihuahua, Mazatlan',
    value: 'America/Mazatlan',
    offset: -6,
  },
  {
    label: 'Mountain Time - Edmonton',
    value: 'America/Edmonton',
    offset: -6,
  },
  {
    label: 'Mountain Time - Yellowknife',
    value: 'America/Yellowknife',
    offset: -6,
  },
  {
    label: 'America Cancun',
    value: 'America/Cancun',
    offset: -5,
  },
  {
    label: 'Bogota',
    value: 'America/Bogota',
    offset: -5,
  },
  {
    label: 'Central Time',
    value: 'America/Chicago',
    offset: -5,
  },
  {
    label: 'Central Time - Mexico City',
    value: 'America/Mexico_City',
    offset: -5,
  },
  {
    label: 'Central Time - Winnipeg',
    value: 'America/Winnipeg',
    offset: -5,
  },
  {
    label: 'Guayaquil',
    value: 'America/Guayaquil',
    offset: -5,
  },
  {
    label: 'Jamaica',
    value: 'America/Jamaica',
    offset: -5,
  },
  {
    label: 'Lima',
    value: 'America/Lima',
    offset: -5,
  },
  {
    label: 'Panama',
    value: 'America/Panama',
    offset: -5,
  },
  {
    label: 'Rio Branco',
    value: 'America/Rio_Branco',
    offset: -5,
  },
  {
    label: 'Asuncion',
    value: 'America/Asuncion',
    offset: -4,
  },
  {
    label: 'Barbados',
    value: 'America/Barbados',
    offset: -4,
  },
  {
    label: 'Boa Vista',
    value: 'America/Boa_Vista',
    offset: -4,
  },
  {
    label: 'Campo Grande',
    value: 'America/Campo_Grande',
    offset: -4,
  },
  {
    label: 'Caracas',
    value: 'America/Caracas',
    offset: -4,
  },
  {
    label: 'Cuiaba',
    value: 'America/Cuiaba',
    offset: -4,
  },
  {
    label: 'Curacao',
    value: 'America/Curacao',
    offset: -4,
  },
  {
    label: 'Detroit',
    value: 'America/Detroit',
    offset: -4,
  },
  {
    label: 'Eastern Time',
    value: 'America/New_York',
    offset: -4,
  },
  {
    label: 'Eastern Time - Iqaluit',
    value: 'America/Iqaluit',
    offset: -4,
  },
  {
    label: 'Eastern Time - Toronto',
    value: 'America/Toronto',
    offset: -4,
  },
  {
    label: 'Grand Turk',
    value: 'America/Grand_Turk',
    offset: -4,
  },
  {
    label: 'Guyana',
    value: 'America/Guyana',
    offset: -4,
  },
  {
    label: 'Havana',
    value: 'America/Havana',
    offset: -4,
  },
  {
    label: 'La Paz',
    value: 'America/La_Paz',
    offset: -4,
  },
  {
    label: 'Manaus',
    value: 'America/Manaus',
    offset: -4,
  },
  {
    label: 'Martinique',
    value: 'America/Martinique',
    offset: -4,
  },
  {
    label: 'Nassau',
    value: 'America/Nassau',
    offset: -4,
  },
  {
    label: 'Port of Spain',
    value: 'America/Port_of_Spain',
    offset: -4,
  },
  {
    label: 'Port-au-Prince',
    value: 'America/Port-au-Prince',
    offset: -4,
  },
  {
    label: 'Porto Velho',
    value: 'America/Porto_Velho',
    offset: -4,
  },
  {
    label: 'Puerto Rico',
    value: 'America/Puerto_Rico',
    offset: -4,
  },
  {
    label: 'Santiago',
    value: 'America/Santiago',
    offset: -4,
  },
  {
    label: 'Santo Domingo',
    value: 'America/Santo_Domingo',
    offset: -4,
  },
  {
    label: 'Araguaina',
    value: 'America/Araguaina',
    offset: -3,
  },
  {
    label: 'Atlantic Time - Halifax',
    value: 'America/Halifax',
    offset: -3,
  },
  {
    label: 'Belem',
    value: 'America/Belem',
    offset: -3,
  },
  {
    label: 'Bermuda',
    value: 'Atlantic/Bermuda',
    offset: -3,
  },
  {
    label: 'Buenos Aires',
    value: 'America/Argentina/Buenos_Aires',
    offset: -3,
  },
  {
    label: 'Cayenne',
    value: 'America/Cayenne',
    offset: -3,
  },
  {
    label: 'Cordoba',
    value: 'America/Argentina/Cordoba',
    offset: -3,
  },
  {
    label: 'Fortaleza',
    value: 'America/Fortaleza',
    offset: -3,
  },
  {
    label: 'Maceio',
    value: 'America/Maceio',
    offset: -3,
  },
  {
    label: 'Montevideo',
    value: 'America/Montevideo',
    offset: -3,
  },
  {
    label: 'Palmer',
    value: 'Antarctica/Palmer',
    offset: -3,
  },
  {
    label: 'Paramaribo',
    value: 'America/Paramaribo',
    offset: -3,
  },
  {
    label: 'Punta Arenas',
    value: 'America/Punta_Arenas',
    offset: -3,
  },
  {
    label: 'Recife',
    value: 'America/Recife',
    offset: -3,
  },
  {
    label: 'Rothera',
    value: 'Antarctica/Rothera',
    offset: -3,
  },
  {
    label: 'Salvador',
    value: 'America/Bahia',
    offset: -3,
  },
  {
    label: 'Sao Paulo',
    value: 'America/Sao_Paulo',
    offset: -3,
  },
  {
    label: 'Stanley',
    value: 'Atlantic/Stanley',
    offset: -3,
  },
  {
    label: 'Thule',
    value: 'America/Thule',
    offset: -3,
  },
  {
    label: 'Newfoundland Time - St. Johns',
    value: 'America/St_Johns',
    offset: -2.5,
  },
  {
    label: 'Godthab',
    value: 'America/Godthab',
    offset: -2,
  },
  {
    label: 'Miquelon',
    value: 'America/Miquelon',
    offset: -2,
  },
  {
    label: 'Noronha',
    value: 'America/Noronha',
    offset: -2,
  },
  {
    label: 'South Georgia',
    value: 'Atlantic/South_Georgia',
    offset: -2,
  },
  {
    label: 'Cape Verde',
    value: 'Atlantic/Cape_Verde',
    offset: -1,
  },
  {
    label: 'Abidjan',
    value: 'Africa/Abidjan',
    offset: 0,
  },
  {
    label: 'Accra',
    value: 'Africa/Accra',
    offset: 0,
  },
  {
    label: 'Azores',
    value: 'Atlantic/Azores',
    offset: 0,
  },
  {
    label: 'Bissau',
    value: 'Africa/Bissau',
    offset: 0,
  },
  {
    label: 'Casablanca',
    value: 'Africa/Casablanca',
    offset: 0,
  },
  {
    label: 'Danmarkshavn',
    value: 'America/Danmarkshavn',
    offset: 0,
  },
  {
    label: 'El Aaiun',
    value: 'Africa/El_Aaiun',
    offset: 0,
  },
  {
    label: 'GMT (no daylight saving)',
    value: 'Etc/GMT',
    offset: 0,
  },
  {
    label: 'Monrovia',
    value: 'Africa/Monrovia',
    offset: 0,
  },
  {
    label: 'Reykjavik',
    value: 'Atlantic/Reykjavik',
    offset: 0,
  },
  {
    label: 'Scoresbysund',
    value: 'America/Scoresbysund',
    offset: 0,
  },
  {
    label: 'UTC',
    value: 'UTC',
    offset: 0,
  },
  {
    label: 'Algiers',
    value: 'Africa/Algiers',
    offset: 1,
  },
  {
    label: 'Canary Islands',
    value: 'Atlantic/Canary',
    offset: 1,
  },
  {
    label: 'Dublin',
    value: 'Europe/Dublin',
    offset: 1,
  },
  {
    label: 'Faeroe',
    value: 'Atlantic/Faroe',
    offset: 1,
  },
  {
    label: 'Lagos',
    value: 'Africa/Lagos',
    offset: 1,
  },
  {
    label: 'Lisbon',
    value: 'Europe/Lisbon',
    offset: 1,
  },
  {
    label: 'London',
    value: 'Europe/London',
    offset: 1,
  },
  {
    label: 'Ndjamena',
    value: 'Africa/Ndjamena',
    offset: 1,
  },
  {
    label: 'Sao Tome',
    value: 'Africa/Sao_Tome',
    offset: 1,
  },
  {
    label: 'Tunis',
    value: 'Africa/Tunis',
    offset: 1,
  },
  {
    label: 'Amsterdam',
    value: 'Europe/Amsterdam',
    offset: 2,
  },
  {
    label: 'Andorra',
    value: 'Europe/Andorra',
    offset: 2,
  },
  {
    label: 'Berlin',
    value: 'Europe/Berlin',
    offset: 2,
  },
  {
    label: 'Brussels',
    value: 'Europe/Brussels',
    offset: 2,
  },
  {
    label: 'Budapest',
    value: 'Europe/Budapest',
    offset: 2,
  },
  {
    label: 'Cairo',
    value: 'Africa/Cairo',
    offset: 2,
  },
  {
    label: 'Central European Time - Belgrade',
    value: 'Europe/Belgrade',
    offset: 2,
  },
  {
    label: 'Central European Time - Prague',
    value: 'Europe/Prague',
    offset: 2,
  },
  {
    label: 'Ceuta',
    value: 'Africa/Ceuta',
    offset: 2,
  },
  {
    label: 'Copenhagen',
    value: 'Europe/Copenhagen',
    offset: 2,
  },
  {
    label: 'Gibraltar',
    value: 'Europe/Gibraltar',
    offset: 2,
  },
  {
    label: 'Johannesburg',
    value: 'Africa/Johannesburg',
    offset: 2,
  },
  {
    label: 'Khartoum',
    value: 'Africa/Khartoum',
    offset: 2,
  },
  {
    label: 'Luxembourg',
    value: 'Europe/Luxembourg',
    offset: 2,
  },
  {
    label: 'Madrid',
    value: 'Europe/Madrid',
    offset: 2,
  },
  {
    label: 'Malta',
    value: 'Europe/Malta',
    offset: 2,
  },
  {
    label: 'Maputo',
    value: 'Africa/Maputo',
    offset: 2,
  },
  {
    label: 'Monaco',
    value: 'Europe/Monaco',
    offset: 2,
  },
  {
    label: 'Kaliningrad',
    value: 'Europe/Kaliningrad',
    offset: 2,
  },
  {
    label: 'Oslo',
    value: 'Europe/Oslo',
    offset: 2,
  },
  {
    label: 'Paris',
    value: 'Europe/Paris',
    offset: 2,
  },
  {
    label: 'Rome',
    value: 'Europe/Rome',
    offset: 2,
  },
  {
    label: 'Stockholm',
    value: 'Europe/Stockholm',
    offset: 2,
  },
  {
    label: 'Tirane',
    value: 'Europe/Tirane',
    offset: 2,
  },
  {
    label: 'Tripoli',
    value: 'Africa/Tripoli',
    offset: 2,
  },
  {
    label: 'Vienna',
    value: 'Europe/Vienna',
    offset: 2,
  },
  {
    label: 'Warsaw',
    value: 'Europe/Warsaw',
    offset: 2,
  },
  {
    label: 'Windhoek',
    value: 'Africa/Windhoek',
    offset: 2,
  },
  {
    label: 'Zurich',
    value: 'Europe/Zurich',
    offset: 2,
  },
  {
    label: 'Amman',
    value: 'Asia/Amman',
    offset: 3,
  },
  {
    label: 'Athens',
    value: 'Europe/Athens',
    offset: 3,
  },
  {
    label: 'Baghdad',
    value: 'Asia/Baghdad',
    offset: 3,
  },
  {
    label: 'Beirut',
    value: 'Asia/Beirut',
    offset: 3,
  },
  {
    label: 'Bucharest',
    value: 'Europe/Bucharest',
    offset: 3,
  },
  {
    label: 'Chisinau',
    value: 'Europe/Chisinau',
    offset: 3,
  },
  {
    label: 'Damascus',
    value: 'Asia/Damascus',
    offset: 3,
  },
  {
    label: 'Gaza',
    value: 'Asia/Gaza',
    offset: 3,
  },
  {
    label: 'Helsinki',
    value: 'Europe/Helsinki',
    offset: 3,
  },
  {
    label: 'Istanbul',
    value: 'Europe/Istanbul',
    offset: 3,
  },
  {
    label: 'Jerusalem',
    value: 'Asia/Jerusalem',
    offset: 3,
  },
  {
    label: 'Kiev',
    value: 'Europe/Kiev',
    offset: 3,
  },
  {
    label: 'Minsk',
    value: 'Europe/Minsk',
    offset: 3,
  },
  {
    label: 'Moscow',
    value: 'Europe/Moscow',
    offset: 3,
  },
  {
    label: 'Nairobi',
    value: 'Africa/Nairobi',
    offset: 3,
  },
  {
    label: 'Nicosia',
    value: 'Asia/Nicosia',
    offset: 3,
  },
  {
    label: 'Qatar',
    value: 'Asia/Qatar',
    offset: 3,
  },
  {
    label: 'Riga',
    value: 'Europe/Riga',
    offset: 3,
  },
  {
    label: 'Riyadh',
    value: 'Asia/Riyadh',
    offset: 3,
  },
  {
    label: 'Sofia',
    value: 'Europe/Sofia',
    offset: 3,
  },
  {
    label: 'Syowa',
    value: 'Antarctica/Syowa',
    offset: 3,
  },
  {
    label: 'Tallinn',
    value: 'Europe/Tallinn',
    offset: 3,
  },
  {
    label: 'Vilnius',
    value: 'Europe/Vilnius',
    offset: 3,
  },
  {
    label: 'Baku',
    value: 'Asia/Baku',
    offset: 4,
  },
  {
    label: 'Dubai',
    value: 'Asia/Dubai',
    offset: 4,
  },
  {
    label: 'Mahe',
    value: 'Indian/Mahe',
    offset: 4,
  },
  {
    label: 'Mauritius',
    value: 'Indian/Mauritius',
    offset: 4,
  },
  {
    label: 'Samara',
    value: 'Europe/Samara',
    offset: 4,
  },
  {
    label: 'Reunion',
    value: 'Indian/Reunion',
    offset: 4,
  },
  {
    label: 'Tbilisi',
    value: 'Asia/Tbilisi',
    offset: 4,
  },
  {
    label: 'Yerevan',
    value: 'Asia/Yerevan',
    offset: 4,
  },
  {
    label: 'Kabul',
    value: 'Asia/Kabul',
    offset: 4.5,
  },
  {
    label: 'Tehran',
    value: 'Asia/Tehran',
    offset: 4.5,
  },
  {
    label: 'Aqtau',
    value: 'Asia/Aqtau',
    offset: 5,
  },
  {
    label: 'Aqtobe',
    value: 'Asia/Aqtobe',
    offset: 5,
  },
  {
    label: 'Ashgabat',
    value: 'Asia/Ashgabat',
    offset: 5,
  },
  {
    label: 'Dushanbe',
    value: 'Asia/Dushanbe',
    offset: 5,
  },
  {
    label: 'Karachi',
    value: 'Asia/Karachi',
    offset: 5,
  },
  {
    label: 'Kerguelen',
    value: 'Indian/Kerguelen',
    offset: 5,
  },
  {
    label: 'Maldives',
    value: 'Indian/Maldives',
    offset: 5,
  },
  {
    label: 'Mawson',
    value: 'Antarctica/Mawson',
    offset: 5,
  },
  {
    label: 'Yekaterinburg',
    value: 'Asia/Yekaterinburg',
    offset: 5,
  },
  {
    label: 'Tashkent',
    value: 'Asia/Tashkent',
    offset: 5,
  },
  {
    label: 'Colombo',
    value: 'Asia/Colombo',
    offset: 5.5,
  },
  {
    label: 'India Standard Time',
    value: 'Asia/Calcutta',
    offset: 5.5,
  },
  {
    label: 'Katmandu',
    value: 'Asia/Katmandu',
    offset: 5.75,
  },
  {
    label: 'Almaty',
    value: 'Asia/Almaty',
    offset: 6,
  },
  {
    label: 'Bishkek',
    value: 'Asia/Bishkek',
    offset: 6,
  },
  {
    label: 'Chagos',
    value: 'Indian/Chagos',
    offset: 6,
  },
  {
    label: 'Dhaka',
    value: 'Asia/Dhaka',
    offset: 6,
  },
  {
    label: 'Omsk',
    value: 'Asia/Omsk',
    offset: 6,
  },
  {
    label: 'Thimphu',
    value: 'Asia/Thimphu',
    offset: 6,
  },
  {
    label: 'Vostok',
    value: 'Antarctica/Vostok',
    offset: 6,
  },
  {
    label: 'Cocos',
    value: 'Indian/Cocos',
    offset: 6.5,
  },
  {
    label: 'Rangoon',
    value: 'Asia/Yangon',
    offset: 6.5,
  },
  {
    label: 'Bangkok',
    value: 'Asia/Bangkok',
    offset: 7,
  },
  {
    label: 'Christmas',
    value: 'Indian/Christmas',
    offset: 7,
  },
  {
    label: 'Davis',
    value: 'Antarctica/Davis',
    offset: 7,
  },
  {
    label: 'Hanoi',
    value: 'Asia/Saigon',
    offset: 7,
  },
  {
    label: 'Hovd',
    value: 'Asia/Hovd',
    offset: 7,
  },
  {
    label: 'Jakarta',
    value: 'Asia/Jakarta',
    offset: 7,
  },
  {
    label: 'Krasnoyarsk',
    value: 'Asia/Krasnoyarsk',
    offset: 7,
  },
  {
    label: 'Brunei',
    value: 'Asia/Brunei',
    offset: 8,
  },
  {
    label: 'Casey',
    value: 'Antarctica/Casey',
    offset: 8,
  },
  {
    label: 'China Time - Beijing',
    value: 'Asia/Shanghai',
    offset: 8,
  },
  {
    label: 'Choibalsan',
    value: 'Asia/Choibalsan',
    offset: 8,
  },
  {
    label: 'Hong Kong',
    value: 'Asia/Hong_Kong',
    offset: 8,
  },
  {
    label: 'Kuala Lumpur',
    value: 'Asia/Kuala_Lumpur',
    offset: 8,
  },
  {
    label: 'Macau',
    value: 'Asia/Macau',
    offset: 8,
  },
  {
    label: 'Makassar',
    value: 'Asia/Makassar',
    offset: 8,
  },
  {
    label: 'Manila',
    value: 'Asia/Manila',
    offset: 8,
  },
  {
    label: 'Irkutsk',
    value: 'Asia/Irkutsk',
    offset: 8,
  },
  {
    label: 'Singapore',
    value: 'Asia/Singapore',
    offset: 8,
  },
  {
    label: 'Taipei',
    value: 'Asia/Taipei',
    offset: 8,
  },
  {
    label: 'Ulaanbaatar',
    value: 'Asia/Ulaanbaatar',
    offset: 8,
  },
  {
    label: 'Western Time - Perth',
    value: 'Australia/Perth',
    offset: 8,
  },
  {
    label: 'Dili',
    value: 'Asia/Dili',
    offset: 9,
  },
  {
    label: 'Jayapura',
    value: 'Asia/Jayapura',
    offset: 9,
  },
  {
    label: 'Yakutsk',
    value: 'Asia/Yakutsk',
    offset: 9,
  },
  {
    label: 'Palau',
    value: 'Pacific/Palau',
    offset: 9,
  },
  {
    label: 'Pyongyang',
    value: 'Asia/Pyongyang',
    offset: 9,
  },
  {
    label: 'Seoul',
    value: 'Asia/Seoul',
    offset: 9,
  },
  {
    label: 'Tokyo',
    value: 'Asia/Tokyo',
    offset: 9,
  },
  {
    label: "Dumont D'Urville",
    value: 'Antarctica/DumontDUrville',
    offset: 10,
  },
  {
    label: 'Eastern Time - Brisbane',
    value: 'Australia/Brisbane',
    offset: 10,
  },
  {
    label: 'Eastern Time - Hobart',
    value: 'Australia/Hobart',
    offset: 10,
  },
  {
    label: 'Eastern Time - Melbourne',
    value: 'Australia/Melbourne',
    offset: 10,
  },
  {
    label: 'Eastern Time - Melbourne, Sydney',
    value: 'Australia/Sydney',
    offset: 10,
  },
  {
    label: 'Guam',
    value: 'Pacific/Guam',
    offset: 10,
  },
  {
    label: 'Vladivostok',
    value: 'Asia/Vladivostok',
    offset: 10,
  },
  {
    label: 'Port Moresby',
    value: 'Pacific/Port_Moresby',
    offset: 10,
  },
  {
    label: 'Truk',
    value: 'Pacific/Chuuk',
    offset: 10,
  },
  {
    label: 'Efate',
    value: 'Pacific/Efate',
    offset: 11,
  },
  {
    label: 'Guadalcanal',
    value: 'Pacific/Guadalcanal',
    offset: 11,
  },
  {
    label: 'Kosrae',
    value: 'Pacific/Kosrae',
    offset: 11,
  },
  {
    label: 'Magadan',
    value: 'Asia/Magadan',
    offset: 11,
  },
  {
    label: 'Norfolk',
    value: 'Pacific/Norfolk',
    offset: 11,
  },
  {
    label: 'Noumea',
    value: 'Pacific/Noumea',
    offset: 11,
  },
  {
    label: 'Ponape',
    value: 'Pacific/Pohnpei',
    offset: 11,
  },
  {
    label: 'Auckland',
    value: 'Pacific/Auckland',
    offset: 12,
  },
  {
    label: 'Fiji',
    value: 'Pacific/Fiji',
    offset: 12,
  },
  {
    label: 'Funafuti',
    value: 'Pacific/Funafuti',
    offset: 12,
  },
  {
    label: 'Kwajalein',
    value: 'Pacific/Kwajalein',
    offset: 12,
  },
  {
    label: 'Majuro',
    value: 'Pacific/Majuro',
    offset: 12,
  },
  {
    label: 'Petropavlovsk-Kamchatskiy',
    value: 'Asia/Kamchatka',
    offset: 12,
  },
  {
    label: 'Nauru',
    value: 'Pacific/Nauru',
    offset: 12,
  },
  {
    label: 'Tarawa',
    value: 'Pacific/Tarawa',
    offset: 12,
  },
  {
    label: 'Wake',
    value: 'Pacific/Wake',
    offset: 12,
  },
  {
    label: 'Wallis',
    value: 'Pacific/Wallis',
    offset: 12,
  },
  {
    label: 'Apia',
    value: 'Pacific/Apia',
    offset: 13,
  },
  {
    label: 'Enderbury',
    value: 'Pacific/Enderbury',
    offset: 13,
  },
  {
    label: 'Fakaofo',
    value: 'Pacific/Fakaofo',
    offset: 13,
  },
  {
    label: 'Tongatapu',
    value: 'Pacific/Tongatapu',
    offset: 13,
  },
  {
    label: 'Kiritimati',
    value: 'Pacific/Kiritimati',
    offset: 14,
  },
];
